export default {
    imageEditors: {
        list: [],
        edit: {},
        modal: {
            imageEditorFirms: [],
            availableLanguages: [],
            availableRoles: []
        }
    }
};
